export const PASSWORD_LABELS = [
  "None",
  "Weak",
  "Fair",
  "Good",
  "Strong",
  "Strong",
];

export const UserRole = {
  creator: "CREATOR",
  viewer: "VIEWER",
};
